import {Component, OnDestroy, OnInit} from '@angular/core';
import {SessionService} from '../Services/Session/session-service.service';
import {RealmService} from '../Services/Realm/realm.service';
import {FirebaseService} from '../Services/Firebase/firebase.service';
import {ApiService} from '../Services/Api/api.service';
import {environment} from '../../environments/environment';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['../../assets/layout/style/layout.css', './profile.component.css']
})
export class ProfileComponent implements OnInit, OnDestroy {
  user: any;
  fbase: FirebaseService;
  coupons: any = null;
  frontUrl: any;
  backUrl: string;
  urlImage:any;
  types = [];
  selectedType = 0;
  showCoupons = false;
  policiesCMI: string;
  isCMI = false;
  env = environment;
  constructor(private st: SessionService, private realm: RealmService, private fb: FirebaseService, private api: ApiService) { }
  ngOnInit() {
    this.realm.getProfileImage();
    this.urlImage = "../../assets/images/avatar/avatar.png";
    this.env.isContentLoading = true;
    this.types = [];
    this.types.push({ label: 'Asegurado', value: 0 });
    this.types.push({ label: 'Dependiente', value: 1 });
    this.fbase = this.fb;

    this.fbase.fetchActivate().then(() => {
      console.log("conexion exitosa");
      this.getPoliciesCMI();
    }).catch(() => {
      console.log("error en conexion ");
    });
    /*this.realm.loginAsync().then(v => {
      this.realm.getCouponSettings();
    });*/
    this.realm.getCouponSettings();
    this.api.responseGetProfile$.subscribe(value => {
      const dat = JSON.parse(JSON.stringify(value));
      const benCmp: object = dat;
      console.log(JSON.stringify(value) + " profile component.ts 35");
      if (dat.code === 701) {
        this.env.isContentLoading = false;
        this.coupons = dat.result.success;
      }
    });
    this.api.responseApiGetProfileImage$.subscribe(value => {
      const dat = JSON.parse(JSON.stringify(value));
      const benCmp: object = dat;
      console.log(JSON.stringify(value) + " get profile data");
      if (dat.status === 200) {
        let data:any = dat.data;
        this.urlImage = data.url;
        console.log("urlImage: "+this.urlImage);
      }
    });
    this.fb.getStringRC('global_name_insure');
    this.st.getData('user').then(data => {
      this.user = data;
     // this.getCard(this.user.showOldCardNumber, this.user);
      console.log(data);
      console.log("currentPolicy "+this.user.policy);
      /*if (this.policiesCMI.indexOf(this.user.policy) > -1) {
        console.log("se excluye contacto");
        this.user.showOldCardNumber = true;
      }*/
      if (this.user.policyHolderCompleteCardNumberOld.indexOf('U') > -1) {
        this.isCMI = true;
      }
    });
  }
  async getPoliciesCMI() {
    this.policiesCMI = await this.fbase.getStringRC('cmi_policy_list');
    //this.env.policiesExclude = this.policiesExclude;
    console.log('cmi_policy_list: ' + this.policiesCMI);
  }
  test(event: any) {
    this.selectedType = event.option.value;
  }
  getCoupons() {
    this.showCoupons = true;
  }
  getCard(showOld: boolean, dependent: any) {
    let qs = '';
    if (showOld) {
      if (dependent.policyHolderCompleteCardNumberOld.indexOf('U') > -1) {
        qs = dependent.policyHolderCompleteCardNumber;
      } else {
        qs = dependent.policyHolderCompleteCardNumberOld;
      }
    } else {
      qs = dependent.policyHolderCompleteCardNumber;
    }
    this.realm.getDigitalCard(qs).then( (d: any) => {
      this.frontUrl = d.front;
      console.log('digitalcard',  this.frontUrl);
      if (this.frontUrl !== '' && this.frontUrl !== null) {
        window.open(
          this.frontUrl,
          '_blank' // <- This is what makes it open in a new window.
        );
      }
    });
  }
  /*showCard(: boolean, dependent: any) {
    this.frontUrl = '';
    let qs = '';
    if (showOld) {
      qs = dependent.policyHolderCompleteCardNumberOld;
    } else {
      qs = dependent.policyHolderCompleteCardNumber;
    }
    this.realm.getDigitalCard(qs);

  }*/
  ngOnDestroy(): void {
  }
}
